import { trimText, stripHtmlTags } from '../../helpers/utils'

const LANG_ID = 1

const TYPE_REDIRECT = {
  tutorial: 'tutorials',
  faq: 'faqs'
}

const getLanguageCol = (colName, langIndex = 1, longFormat = false) => {
  if (langIndex === 1 && longFormat === false) {
    return colName
  }
  return `${colName}_language_${langIndex}`
}

const getUrl = (item) => {
  const contentType = TYPE_REDIRECT[item.type]
  const id = item.id || item.pk
  return `/${contentType}/${id}?device=${item.phonefk}`
}

const getHighlights = (item, key) => {
  return item.highlight && item.highlight[key]
}

const getTitle = (item) => {
  const titleKey = getLanguageCol('heading', LANG_ID, true)
  const highlights = getHighlights(item, titleKey)

  if (highlights && highlights.length > 0) {
    return highlights[0]
  }

  if (
    item.fields &&
    item.fields[titleKey] &&
    item.fields[titleKey].length > 0
  ) {
    return item.fields[titleKey][0]
  }

  return 'Title missing'
}

const getDescription = (item) => {
  const descriptionKey = getLanguageCol('description', LANG_ID, true)
  const highlights = getHighlights(item, descriptionKey)
  const descriptions = item.fields && item.fields[descriptionKey]

  if (highlights && highlights.length > 0) {
    return highlights.join(' ... ')
  }

  if (descriptions && descriptions.length > 0) {
    return trimText(stripHtmlTags(descriptions[0]), 300)
  }

  return ''
}

export default {
  addTitle: () => (item) => {
    return { ...item, title: getTitle(item) }
  },

  addDescription: () => (item) => {
    return { ...item, description: getDescription(item) }
  },

  addUrl: () => (item) => {
    return { ...item, url: getUrl(item) }
  }
}
